import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { useProjectStore } from '@/store/projectStore';
import { isWebApp } from '@/webapp/webAppRecord';
import { timeAgo } from '@/utils/time';
import type { AppDefinition } from '@/types/app';
import { Chip, EmptyState, FAB, IdentityChip, Screen } from '../ui';

/** Ported from src/app/(main)/(tabs)/index.tsx — the projects you are building. */
export default function Home() {
  const navigate = useNavigate();
  const projects = useProjectStore((s) => s.projects);
  const isLoading = useProjectStore((s) => s.isLoading);

  useEffect(() => {
    void useProjectStore.getState().loadProjects();
  }, []);

  return (
    <Screen title="Build">
      {projects.length === 0 && !isLoading ? (
        <EmptyState
          icon="emptyApps"
          title="No projects yet"
          body="Describe an app in a sentence and Saddle builds it."
          ctaTitle="Create an app"
          onCta={() => navigate('/new/idea')}
        />
      ) : (
        <ul className="project-list app-grid">
          {projects.map((p) => {
            const definition = p.definition as AppDefinition;
            return (
              <li key={p.id}>
                <button
                  type="button"
                  className="card clay-card pressable project-row"
                  onClick={() => navigate(`/project/${p.id}`)}
                >
                  <IdentityChip name={p.name} />
                  <span className="project-text">
                    <span className="type-heading">{p.name}</span>
                    <span className="type-caption project-meta">{timeAgo(p.updated_at)}</span>
                  </span>
                  {definition.webUrl && <Chip label="Live" tone="success" />}
                  {!isWebApp(definition) && <Chip label="Phone only" tone="neutral" />}
                </button>
              </li>
            );
          })}
        </ul>
      )}
      <FAB icon="add" onPress={() => navigate('/new/idea')} accessibilityLabel="New app" />
    </Screen>
  );
}
